export default __webpack_public_path__ + "static/media/futurama-title.4161b8d0.jpeg";